import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchGymLandingPagesData } from "../../redux/website-reducers/websiteSlice";
import GymLandingPagesList from "../../components/website-contents/gym-landing-pages/GymLandingPagesList";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import GymLandingPageForm from "../../components/website-contents/gym-landing-pages/GymLandingPageForm";

const GymLandingPages = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    isActive: "",
    selectedAccountType: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    default_for: allFilters.selectedAccountType?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getGymLandingPagesList(filters) {
    dispatch(
      fetchGymLandingPagesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getGymLandingPagesList(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      default_for: allFilters.selectedAccountType?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedAccountType, allFilters.isActive]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Gym Landing Details Pages">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Offer Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "add" || modValues.modName === "edit"
                ? "mod-width-50p"
                : ""
            }`}>
            {modValues.modName === "add" ||
            modValues.modName === "edit" ? null : (
              <ModalHeadAndClose
                title={`${modValues.modName?.replace(/_/g, " ")}`}
                onClose={onCloseModal}
              />
            )}

            {modValues.modName === "add" || modValues.modName === "edit" ? (
              <GymLandingPageForm
                userInfoData={userInfoData}
                closeModal={onCloseModal}
                callFunction={() => getGymLandingPagesList(filters)}
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Gym Landing Details Pages"}
              createBtnTxt={"+ Add New Gym Landing Details Page"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
              isReload={() => getGymLandingPagesList(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <GymLandingPagesList
              userInfoData={userInfoData}
              callFunction={() => getGymLandingPagesList(filters)}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
            
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default GymLandingPages;
